import { FNTData } from "../../../api/generated";
import {
  createReportContext,
  type InferReport,
} from "../../../context/ReportContext";

const clientFundedNotTradedReport = createReportContext({
  rebateAccountIDs: "multi",
})<
  // Filter props type
  { rebateAccountIDs: string },
  // Resources
  {
    table: {
      fntList: FNTData[];
      totalCount: number;
    };
    csv: void;
  },
  // State type
  {
    startDate: string;
    endDate: string;
    selected: {
      rebateAccountIDs: string[] | null;
    };
    search: string;
    page: number;
    pageSize: number;
    sortColumn: string | null;
    sortDesc: boolean | null;
  }
>();

export const {
  Provider: ClientFundedNotTradedReportContextProvider,
  useReportContext: useClientFundedNotTradedReportContext,
} = clientFundedNotTradedReport;

export type ClientFundedNotTradedReportParams = InferReport<
  typeof clientFundedNotTradedReport,
  "params"
>;

export type ClientFundedNotTradedReportStates = InferReport<
  typeof clientFundedNotTradedReport,
  "states"
>;
